import { FormInstance } from "antd";
import { MessageApi } from "antd/lib/message";

type IOnConfirmDrawerNewDocument = {
  form: FormInstance<any>;
  maskAllowLetters: boolean;
  maskAllowNumbers: boolean;
  maskAllowSpecialCharacters: boolean;
  maskMinCharacters: number;
  maskMaxCharacters: number;
  message: MessageApi;
  messageDescription: string;
  documentSaveNewDocumentAsync: (...args) => void;
};

type IOnConfirmDrawerUpdateDocument = {
  formEdit: FormInstance<any>;
  documentId: number;
  maskAllowLetters: boolean;
  maskAllowNumbers: boolean;
  maskAllowSpecialCharacters: boolean;
  maskMinCharacters: number;
  maskMaxCharacters: number;
  message: MessageApi;
  messageDescription: string;
  documentUpdateDocumentAsync: (...args) => void;
};

export const onConfirmDrawerNewDocument = async ({
  form,
  maskAllowLetters,
  maskAllowNumbers,
  maskAllowSpecialCharacters,
  maskMinCharacters,
  maskMaxCharacters,
  documentSaveNewDocumentAsync,
  message,
  messageDescription,
}: IOnConfirmDrawerNewDocument): Promise<void> => {
  try {
    const formaData = await form.validateFields();
    const { documentDescription } = formaData;
    const bodyRequest = {
      description: documentDescription,
      maskRules: {
        allowLetters: maskAllowLetters,
        allowNumbers: maskAllowNumbers,
        allowSpecialCharacters: maskAllowSpecialCharacters,
        minCharacters: maskMinCharacters,
        maxCharacters: maskMaxCharacters,
      },
    };
    documentSaveNewDocumentAsync(bodyRequest);
  } catch (e) {
    console.error(new Error("Document form validation error"));
    message.error(messageDescription);
  }
};

export const onConfirmDrawerUpdateDocument = async ({
  formEdit,
  documentId,
  maskAllowLetters,
  maskAllowNumbers,
  maskAllowSpecialCharacters,
  maskMinCharacters,
  maskMaxCharacters,
  documentUpdateDocumentAsync,
  message,
  messageDescription,
}: IOnConfirmDrawerUpdateDocument): Promise<void> => {
  try {
    await formEdit.validateFields();
    const documentDescription = formEdit.getFieldValue("documentDescription");
    const bodyRequest = {
      documentId,
      description: documentDescription,
      maskAllowLetters,
      maskAllowNumbers,
      maskAllowSpecialCharacters,
      maskMinCharacters,
      maskMaxCharacters,
    };
    documentUpdateDocumentAsync(bodyRequest);
  } catch (e) {
    console.error(new Error("Document form validation error"));
    message.error(messageDescription);
  }
};
